var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"clearable":"","label":_vm.$t('Bill-Type'),"items":_vm.items,"item-text":"RecieptTypeName","item-value":"ID","rules":_vm.rules,"return-object":"","placeholder":this.$t('Please-Choose')},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }